import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
const useMonthList = () => {
	const { i18n } = useTranslation()
	const { language } = i18n
	const monthList = useMemo(() => {
		const monthList = [
			{
				value: '01',
				title_uz: 'Yanvar',
			},
			{
				value: '02',
				title_uz: 'Fevral',
			},
			{
				value: '03',
				title_uz: 'Mart',
			},
			{
				value: '04',
				title_uz: 'Aprel',
			},
			{
				value: '05',
				title_uz: 'May',
			},
			{
				value: '06',
				title_uz: 'Iyun',
			},
			{
				value: '07',
				title_uz: 'Iyul',
			},
			{
				value: '08',
				title_uz: 'Avgust',
			},
			{
				value: '09',
				title_uz: 'Sentabr',
			},
			{
				value: '10',
				title_uz: 'Oktabr',
			},
			{
				value: '11',
				title_uz: 'Noyabr',
			},
			{
				value: '12',
				title_uz: 'Dekabr',
			},
		]
		const newMonthList = monthList.map(month => ({
			...month,
			label: month?.['title_' + language],
		}))
		return newMonthList
	}, [language])
	return monthList
}
export default useMonthList
